export const AP_SALESFORCE = 'salesforce';

export type AuthProvider = (
  | typeof AP_SALESFORCE
);
